"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ToastContext_1 = require("context/ToastContext");
const UserContext_1 = require("context/UserContext");
const HelperUtils_1 = require("utils/HelperUtils");
const ObjectivesHelper_1 = require("utils/ObjectivesHelper");
const Button_1 = __importDefault(require("components/design-system/Button"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const ExportSummaryButton = ({ owner, filter = {}, extraFilter = {}, placementId, customClass = '', withTitle = true }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const { user } = (0, UserContext_1.useUser)();
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const handleClick = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.stopPropagation();
        setIsLoading(true);
        addToast((0, ObjectivesHelper_1.getObjectiveSummaryPdfToast)(owner, user));
        yield (0, ObjectivesHelper_1.getObjectiveSummaryPdf)({
            ownerId: owner === null || owner === void 0 ? void 0 : owner.id,
            recipientId: user === null || user === void 0 ? void 0 : user.id,
            filter,
            extraFilter,
            placementId
        });
        setIsLoading(false);
    });
    return (react_1.default.createElement("div", { className: customClass },
        react_1.default.createElement(TooltipContainer_1.default, { show: !withTitle, text: (0, HelperUtils_1.getObjectiveLocale)('Export Summary') },
            react_1.default.createElement(Button_1.default.Secondary, { onClick: (e) => handleClick(e), customClass: withTitle ? '' : '!px-[4px]', isLoading: isLoading },
                react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-file_download", size: 24, fillColor: "var(--n-600)" }),
                withTitle && (react_1.default.createElement("p", { className: "ml-[4px]" }, (0, HelperUtils_1.getObjectiveLocale)('Export Summary')))))));
};
exports.default = ExportSummaryButton;
